export default "__VITE_ASSET__DuCfAQO9__"